import type { Connection, ConnectionStatus } from '@/contract'

/* Status colours (BRAND.md system states): tinted chip, dark ink text, 6px dot. */

type Tone = { dot: string; ink: string; bg: string; order: number; word: string }

const TONES: Record<ConnectionStatus, Tone> = {
    down: { dot: 'var(--red)', ink: 'var(--red-ink)', bg: 'var(--red-bg)', order: 0, word: 'Sem resposta' },
    ok: { dot: 'var(--ok)', ink: 'var(--ok-ink)', bg: 'var(--ok-bg)', order: 1, word: 'Funcionando' },
    testing: { dot: 'var(--info)', ink: 'var(--info)', bg: 'var(--info-bg)', order: 2, word: 'Em testes' },
    waiting: { dot: 'var(--yellow)', ink: 'var(--yellow-ink)', bg: 'var(--yellow-bg)', order: 3, word: 'Aguardando' },
    unknown: { dot: 'var(--muted)', ink: 'var(--muted)', bg: 'var(--sand)', order: 4, word: 'Sem informação' },
}

export function toneOf(status: ConnectionStatus): Tone {
    return TONES[status]
}

/** No live link to draw (dashed line, latency "sem acesso"). */
export function hasNoLink(status: ConnectionStatus): boolean {
    return status === 'waiting' || status === 'down' || status === 'unknown'
}

export function latencyText(c: Connection): string {
    if (c.status === 'waiting') return 'sem acesso'
    if (c.status === 'down') return 'sem resposta'
    return c.latencyMs === null ? '—' : `${c.latencyMs} ms`
}

export type StatusGroup = { status: ConnectionStatus; word: string; items: Connection[] }

/** Connections grouped by status, problems first. */
export function groupByStatus(connections: Connection[]): StatusGroup[] {
    const groups = new Map<ConnectionStatus, Connection[]>()
    for (const c of connections) groups.set(c.status, [...(groups.get(c.status) ?? []), c])
    return [...groups.entries()]
        .sort((a, b) => TONES[a[0]].order - TONES[b[0]].order)
        .map(([status, items]) => ({ status, word: items[0]?.statusLabel || TONES[status].word, items }))
}
